import { IIndexable, key } from 'core-ts-types';
import * as _4 from 'lodash4';
/**
 * old name was PlannerCourseBuilder
 */
export class APSectionType implements IIndexable {
  id: key;
  nk: string;
  cd: string;
  name: string;
  term: key;
  course: key;
  is_required: boolean;
  is_active: boolean;
  rank: number;

  constructor(sectionType: Partial<APSectionType>) {
    _4.merge(
      this,
      {
        name: sectionType.cd
      },
      sectionType
    );
  }

  static build(sectionType: Partial<APSectionType>): APSectionType {
    return new APSectionType(sectionType);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_section_type_builder.ts